import React from 'react';
import { VStack, HStack, Link, Text, Box } from '@chakra-ui/react';
import { FiExternalLink } from 'react-icons/fi';

const PlatformPolicyList = ({ links }) => {
  if (!links?.length) return null;
  return (
    <VStack as="ul" align="stretch" spacing={2} listStyleType="none" mt={3}>
      {links.map(({ label, url }) => (
        <Box as="li" key={url}>
          <Link
            href={url}
            isExternal
            display="inline-flex"
            alignItems="center"
            gap={1.5}
            color="brand.700"
            fontWeight="500"
            fontSize="sm"
            _hover={{ textDecoration: 'underline' }}
          >
            <Text as="span">{label}</Text>
            <FiExternalLink size={12} />
          </Link>
        </Box>
      ))}
    </VStack>
  );
};

export default PlatformPolicyList;
